const congressTag = 'subConDec23'
const congressTagOneDay = 'subConDec23OneDay'
const congressWebinarIds = [1292, 1295, 1296]
const congressWebinarId = congressWebinarIds[1]
const congressTranslationLink = `https://medpoint.pro/webinar/${congressWebinarId}`

interface IProgramWebinar {
  time: string // Время начала в плашке
  duration?: string // продолжительность в плашке
  title: string // в плашке
  key: number
  lectors?: string[] // в плашке, если нет лекторов текст встанет в центр
  symposiumTitle?: string //  Главное имя над  плашкой
  symposiumUpTitle?: string // Оранжевое имя над плашкой
  symposium?: string // Добавит стиль( оранжевую обводку). symposium: 'last' или  symposium: 'true' - вроде как делают одно и тоже
}
interface IProgram {
  [day: string]: IProgramWebinar[]
}

const program: IProgram = {
  '13 ДЕКАБРЯ': [
    {
      time: '10:00',
      duration: '25 мин.',
      title: 'Иммунотерапия болезни Альцгеймера: возможности и перспективы',
      lectors: ['Чуров А.В.'],
      symposiumTitle: 'Трансляционные подходы в геронауке',
      symposiumUpTitle: 'СЕКЦИЯ 1',
      key: 1,
    },
    {
      time: '10:25',
      duration: '25 мин.',
      title: 'Когнитивные нарушения среди долгожителей: поиск молекулярно-генетических механизмов',
      lectors: ['Каштанова Д.А.'],
      key: 2,
    },
    {
      time: '10:50',
      duration: '25 мин.',
      title: 'Молекулярная диагностика нейродегенеративных заболеваний: задачи и проблемы',
      lectors: ['Сергеева С.П.'],
      key: 3,
    },
    {
      time: '11:15',
      duration: '25 мин.',
      title:
        'Текущие проекты и перспективы развития лаборатории искусственного интеллекта и биоинформатики',
      lectors: ['Арбатский М.С.'],
      key: 4,
    },
    {
      time: '11:40',
      duration: '10 мин.',
      title: 'Дискуссия',
      key: 5,
    },
    {
      time: '11:50',
      duration: '20 мин.',
      title:
        'Биогеронтологическое обоснование снижения биологического возраста с помощью БАД на основе терпенов «Кардиоорганик» (при поддержке компании ООО «Инитиум-Фарм», не аккредитуется в НМО)',
      lectors: ['Маганова Ф.И.'],
      symposiumTitle: 'Геропротекторные технологии',
      symposiumUpTitle: 'СЕКЦИЯ 2',
      key: 6,
    },
    {
      time: '12:10',
      duration: '20 мин.',
      title:
        'Береги микробиоту смолоду (при поддержке компании ООО «БИОКОДЕКС», не аккредитуется в НМО)',
      lectors: ['Полуэктова E.A.'],
      key: 7,
    },
    {
      time: '12:30',
      duration: '20 мин.',
      title:
        'Старение костно-мышечной системы: возможности современной медицины (при поддержке компании ЗАО «ФармФирма «Сотекс», не аккредитуется в НМО)',
      lectors: ['Ткачева О.Н.'],
      key: 8,
    },
    {
      time: '12:50',
      duration: '30 мин.',
      title: 'Гормонально-метаболический статус долгожителей',
      lectors: ['Мачехина Л.В.'],
      key: 9,
    },
    {
      time: '13:20',
      duration: '10 мин.',
      title: 'Дискуссия',
      key: 10,
    },
    {
      time: '13:30',
      duration: '40 мин.',
      title: 'Артериальная гипертензия у мультиморбидных пациентов',
      lectors: ['Котовская Ю.В.'],
      symposiumTitle:
        'Современные подходы к терапии пациентов с ССЗ (при поддержке компании «Берлин-Хеми/А. Менарини», не аккредитуется в НМО)',
      symposiumUpTitle: 'СЕКЦИЯ 3',
      key: 11,
    },
    {
      time: '14:10',
      duration: '40 мин',
      title: 'Качество жизни и прогноз сложных пациентов с ИБС',
      lectors: ['Шахнович Р.М.'],
      key: 12,
    },
    {
      time: '14:50',
      duration: '10 мин.',
      title: 'Дискуссия',
      key: 13,
    },
    {
      time: '15:00',
      duration: '25 мин.',
      title: 'Виды физической нагрузки, имеющие научное обоснование для долголетия',
      lectors: ['Ерусланова К.А.'],
      symposiumTitle: 'Исследования по изучению долголетия',
      symposiumUpTitle: 'СЕКЦИЯ 4',
      key: 14,
    },
    {
      time: '15:25',
      duration: '25 мин.',
      title:
        'Взаимосвязь уровня ИФР-1 и показателей гормонально-метаболического статуса, выживаемости у долгожителей',
      lectors: ['Ильющенко А.К.'],
      key: 15,
    },
    {
      time: '15:50',
      duration: '10 мин.',
      title: 'Дискуссия',
      key: 16,
    },
  ],
  '14 ДЕКАБРЯ': [
    {
      time: '10:00',
      duration: '20 мин.',
      title: 'Приветственное слово',
      lectors: ['Пирадов М.А.', 'Стародубов В.И.'],
      symposiumTitle: ' ',
      symposiumUpTitle: 'Торжественное открытие',
      key: 17,
    },
    // {
    //   time: '10:10',
    //   duration: '10 мин.',
    //   title: 'Приветственное слово',
    //   lectors: ['Стародубов В.И.'],
    //   key: 18,
    // },
    {
      time: '10:20',
      duration: '30 мин.',
      title: 'Геронтология: состояние на сегодняшний день и перспективы развития',
      lectors: ['Ткачева О.Н.'],
      symposiumTitle: ' ',
      symposiumUpTitle: 'Панельная дискуссия',
      key: 19,
    },
    {
      time: '10:50',
      duration: '30 мин.',
      title: 'Системный взгляд на биомаркеры старения и геропротекторы',
      lectors: ['Москалев А.А.'],
      key: 20,
    },
    {
      time: '11:20',
      duration: '30 мин.',
      title: 'Медицина долголетия',
      lectors: ['Стражеско И.Д.'],
      key: 21,
    },
    {
      time: '11:50',
      duration: '10 мин.',
      title: 'Дискуссия',
      key: 22,
    },
    // {
    //   time: '11:40',
    //   duration: '20 мин.',
    //   title: 'Медицина долголетия',
    //   key: 23,
    //   lectors: ['Стражеско И.Д.'],
    // },
    {
      time: '12:00',
      duration: '20 мин.',
      title: 'Институт изучения старения: основные направления исследований и первые итоги работы',
      lectors: ['Чуров А.В.'],
      symposiumTitle: 'Институт старения. Направление исследований',
      key: 24,
      symposiumUpTitle: 'СЕКЦИЯ 1',
    },
    {
      time: '12:20',
      duration: '15 мин.',
      title:
        'Шесть функций дыхания: не пора ли взять под контроль производство АФК в митохондриях, а вместе с ним и старение?',
      key: 25,
      lectors: ['Лямзаев К.Г.'],
    },
    {
      time: '12:35',
      duration: '15 мин.',
      title: 'Оценка биологического возраста на основе данных ЭхоКГ',
      key: 26,
      lectors: ['Кобеляцкая А.А.'],
    },
    {
      time: '12:50',
      duration: '15 мин.',
      title: 'Особенности липидома у долгожителей',
      key: 27,
      lectors: ['Хайтович Ф.Е.'],
    },
    {
      time: '13:05',
      duration: '15 мин.',
      title: 'Транскрипционный фактор Nrf2 как регулятор старения млекопитающих',
      key: 28,
      lectors: ['Зиновкин Р.А.'],
    },
    {
      time: '13:20',
      duration: '10 мин.',
      key: 29,
      title: 'Дискуссия',
    },
    {
      time: '13:30',
      key: 30,
      duration: '30 мин.',
      title: 'Ланч',
    },
    {
      time: '14:00',
      duration: '20 мин.',
      title: 'Геронтология в Сербии: прошлое, настоящее и будущее',
      lectors: ['Горан Сево'],
      symposiumTitle: 'Передовые рубежи геронауки в мире. Часть I',
      key: 31,
      symposiumUpTitle: 'СЕКЦИЯ 2',
    },
    {
      time: '14:20',
      duration: '20 мин.',
      title:
        'Саркопения и старческая астения: влияние концептуальных и функциональных изменений за последние два десятилетия',
      key: 32,
      lectors: ['Роберто Алвес Лоренсу'],
    },
    {
      time: '14:40',
      duration: '20 мин.',
      title: 'Как замедлить биологические часы? Роль диеты и физических нагрузок',
      lectors: ['Луиджи Фонтана'],
      key: 33,
    },
    {
      time: '15:00',
      duration: '20 мин.',
      title:
        'Как продлить здоровый период жизни? Применение знаний, полученных в результате исследований долголетия',
      lectors: ['Брайан Кеннеди'],
      key: 34,
    },
    {
      time: '15:20',
      duration: '10 мин.',
      title: 'Дискуссия',
      key: 35,
    },
    {
      time: '15:30',
      duration: '10 мин.',
      title: 'Кофе-брейк',
      key: 36,
    },
    {
      time: '15:40',
      duration: '20 мин.',
      title:
        'Редокс-регуляция устойчивости мозга в условиях нормы и патологии: от лабораторных исследований до пациента',
      lectors: ['Витторио Калабрезе'],
      symposiumTitle: 'Передовые рубежи геронауки в мире. Часть II',
      symposiumUpTitle: 'СЕКЦИЯ 3',
      key: 37,
    },
    {
      time: '16:00',
      duration: '20 мин.',
      title:
        'Необходимость валидации приборов для измерения артериального давления. Приложение для устройств Witlings',
      lectors: ['Роланд Асмар'],
      key: 38,
    },
    {
      time: '16:20',
      duration: '20 мин.',
      title:
        'Изменения в структуре хроматина при преждевременном старении, обусловленном ламинопатией',
      lectors: ['Чжунцзюнь Чжоу'],
      key: 39,
    },
    {
      time: '16:40',
      duration: '20 мин.',
      title:
        'Генетические и эпигенетические основы физического здоровья в медицине здорового долголетия',
      lectors: ['Кристин Юань Хуан'],
      key: 40,
    },
    {
      time: '17:00',
      duration: '10 мин.',
      title: 'Дискуссия',
      key: 41,
    },
    {
      time: '17:10',
      duration: '10 мин.',
      title: 'Кофе-брейк',
      key: 42,
    },
    {
      time: '17:20',
      duration: '20 мин.',
      title:
        'Особенности эпигенетической возрастной акселерации у жителей Якутии (предварительная тема)',
      lectors: ['Иванченко М.В.'],
      symposiumTitle: 'Фундаментальные исследования в геронтологии',
      symposiumUpTitle: 'СЕКЦИЯ 4',
      key: 43,
    },
    {
      time: '17:40',
      duration: '20 мин.',
      title: 'Системная биология – «Введение в системную биологию на примере Ферроптоза»',
      lectors: ['Арбатский М.С'],
      key: 44,
    },
    {
      time: '18:00',
      duration: '20 мин.',
      title: 'Генетика старения и долголетия',
      lectors: ['Рогаев Е. И.'],
      key: 45,
    },
    {
      time: '18:20',
      duration: '20 мин.',
      title: 'Анализ одиночных клеток в изучении старения',
      lectors: ['Гусев Ф.Е.'],
      key: 46,
    },
    {
      time: '18:40',
      duration: '10 мин.',
      title: 'Дискуссия',
      key: 47,
    },
    {
      time: '18:50',
      title: 'Закрытие 1-го дня',
      key: 48,
    },
  ],
  '15 ДЕКАБРЯ': [
    {
      time: '10:00',
      duration: '20 мин.',
      title: 'RUSS-AGE — первое в России исследование старения',
      lectors: ['Тяжельников А.А'],
      symposiumTitle: 'RUSS-AGE',
      symposiumUpTitle: 'СЕКЦИЯ 1',
      key: 49,
    },
    {
      time: '10:20',
      duration: '20 мин.',
      title: 'Калькулятор биологического возраста',
      lectors: ['Мельницкая А.А.'],
      key: 50,
    },
    {
      time: '10:40',
      duration: '20 мин.',
      title: 'Комплексная геронтологическая оценка',
      lectors: ['Мачехина Л.В.'],
      key: 51,
    },
    {
      time: '11:00',
      duration: '10 мин.',
      title: 'Дискуссия',
      key: 52,
    },
    {
      time: '11:10',
      duration: '20 мин.',
      title: 'Способы когнитивной адаптации при старении',
      lectors: ['Чердак М.А.'],
      symposiumTitle: 'Медицина долголетия',
      symposiumUpTitle: 'СЕКЦИЯ 2',
      key: 53,
    },
    {
      time: '11:30',
      duration: '20 мин.',
      title: 'Горе от ума',
      lectors: ['Данилов А.Б.'],
      key: 54,
    },
    {
      time: '11:50',
      duration: '20 мин.',
      title: 'Геронтология в Аюрведе',
      lectors: ['Доктор Наушад'],
      key: 55,
    },
    {
      time: '12:10',
      duration: '10 мин.',
      title: 'Дискуссия',
      key: 56,
    },
    {
      time: '12:20',
      duration: '10 мин.',
      title: 'Кофе-брейк',
      key: 57,
    },
    {
      time: '12:30',
      duration: '20 мин.',
      title: 'Старение сосудов и биология теломер: роль дефицита витамина Д3',
      lectors: ['Дудинская Е.Н.'],
      symposiumTitle: 'Эндокринология старения',
      symposiumUpTitle: 'СЕКЦИЯ 3',
      key: 58,
    },
    {
      time: '12:50',
      duration: '20 мин.',
      title: 'Менопаузальная гормонатерапия в профилактике возраст-ассоциированных заболеваний',
      lectors: ['Орлова Я.А.'],
      key: 59,
    },
    {
      time: '13:10',
      duration: '20 мин.',
      title: 'Эндокринные особенности старения мужчин',
      lectors: ['Павлова З.Ш.'],
      key: 60,
    },
    {
      time: '13:30',
      duration: '10 мин.',
      title: 'Дискуссия',
      key: 61,
    },
    {
      time: '13:40',
      duration: '30 мин.',
      title: 'Ланч',
      key: 62,
    },
    {
      time: '14:10',
      duration: '20 мин.',
      title: 'Микробиота и возрастные изменения',
      lectors: ['Карасев А.В.'],
      symposiumTitle: 'Геронтология без границ. Часть 1',
      symposiumUpTitle: 'СЕКЦИЯ 4',
      key: 63,
    },
    {
      time: '14:30',
      duration: '20 мин.',
      title:
        'Взаимосвязь клинических показателей и биомаркеров накопления сенесцентных клеток у пожилых пациентов',
      lectors: ['Клементьева А.Г.'],
      key: 64,
    },
    {
      time: '14:50',
      duration: '20 мин.',
      title:
        'Конечные продукты гликации (КПГ) как маркеры старения и развития возраст-ассоциированных заболеваний',
      lectors: ['Садыков Р.Ф.'],
      key: 65,
    },
    {
      time: '15:10',
      duration: '10 мин.',
      title: 'Дискуссия',
      key: 66,
    },
    {
      time: '15:20',
      duration: '20 мин.',
      title: 'Возрастные аспекты церебральных инсультов',
      lectors: ['Мартынов М.Ю.'],
      symposiumTitle: 'Геронтология без границ. Часть 2',
      symposiumUpTitle: 'СЕКЦИЯ 5',
      key: 67,
    },
    {
      time: '15:40',
      duration: '20 мин.',
      title: 'Когнитивный статус у долгожителей',
      lectors: ['Исаев Р.И.'],
      key: 68,
    },
    {
      time: '16:00',
      duration: '20 мин.',
      title: 'Резервы роста ожидаемой продолжительности жизни пожилого населения в России',
      lectors: ['Папанова Е.К.'],
      key: 69,
    },
    {
      time: '16:20',
      duration: '10 мин.',
      title: 'Дискуссия',
      key: 70,
    },
    {
      time: '16:30',
      duration: '10 мин.',
      title: 'Кофе-брейк',
      key: 71,
    },
    {
      time: '16:40',
      duration: '20 мин.',
      title: 'Презентация приложения по питанию',
      symposiumTitle:
        'Общества молодых исследователей проблем старения: изобретения, вдохновение, общение в контексте геронауки',
      symposiumUpTitle: 'СЕКЦИЯ 6',
      key: 72,
    },
    {
      time: '17:00',
      duration: '20 мин.',
      title: '10 вопросов молодому ученому',
      lectors: ['Черноскулова Е.А.'],
      key: 73,
    },
    {
      time: '17:20',
      duration: '20 мин.',
      title: 'Ученые и журналисты: взаимовыгодное сотрудничество на благо пациентов',
      lectors: ['Рогачева А.И.'],
      key: 74,
    },
    {
      time: '17:40',
      duration: '10 мин.',
      title: 'Дискуссия',
      key: 75,
    },
    {
      time: '17:50',
      duration: '30 мин.',
      title: 'Закрытие',
      lectors: ['Ткачева О.Н., Стражеско И.Д.'],
      key: 76,
    },
  ],
}

export {
  congressTag,
  congressTagOneDay,
  congressWebinarIds,
  congressWebinarId,
  congressTranslationLink,
  program,
}
export type { IProgramWebinar }
